import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import AppAlert from "@/components/AppAlert.vue";
import {computed, ref} from "vue";
import {useStore} from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileDeletionModal',
  props: {
    show: { type: Boolean, default: false }
  },
  emits: ["ok", "cancel"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const store = useStore()

const email = ref<string>('')

const configuration = computed(() => store.state.configuration)
if (configuration.value) {
  email.value = configuration.value.user.email
}

const onOk = () => {
  emit('ok', email.value)
  email.value = ''
}
const onCancel = () => {
  emit('cancel')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppAlert, {
    show: _ctx.show,
    title: "Zugang löschen",
    "show-cancel": "",
    onOk: onOk,
    onCancel: onCancel
  }, {
    default: _withCtx(() => [
      _createTextVNode(" Mit dem Löschen Ihres Zugangs werden auch alle Ihre ausgefüllten Fragebögen unwiederruflich gelöscht."),
      _hoisted_1,
      _hoisted_2,
      _createTextVNode("Löschvorgang durchführen? ")
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})